import React from 'react';

import { useIntl } from 'react-intl-next';

import EmptyState from '@atlaskit/empty-state';

import { EmptySearch } from '../assets';

import messages from './messages';

export const LinkPickerEmptyState = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<EmptyState
			header={formatMessage(messages.emptyStateHeader)}
			maxImageWidth={250}
			description={formatMessage(messages.emptyStateDescription)}
			imageUrl={EmptySearch}
			width="wide"
		/>
	);
};
